export const vehicleSizes: { label: string; value: string }[] = [
  { label: 'solo', value: 'solo' },
  { label: 'double_trailer', value: 'double_trailer' },
  { label: 'bus', value: 'bus' },
];

export const requiredTrackBodies: { label: string; value: string }[] = [
  { label: 'curtainsider', value: 'curtainsider' },
  { label: 'cooler', value: 'cooler' },
  { label: 'standard-tent', value: 'standard-tent' },
  { label: 'isotherm', value: 'isotherm' },
  { label: 'mega', value: 'mega' },
  { label: 'coilmulde', value: 'coilmulde' },
  { label: 'hook-truck', value: 'hook-truck' },
  { label: 'swap-body-system', value: 'swap-body-system' },
  { label: '20-standard', value: '20-standard' },
  { label: '40-standard', value: '40-standard' },
  { label: '45-standard', value: '45-standard' },
  { label: 'joloda', value: 'joloda' },
  { label: 'BDE', value: 'BDE' },
  { label: 'walkingfloor', value: 'walkingfloor' },
  { label: 'jumbo', value: 'jumbo' },
];

export const currencies: { label: string; value: string }[] = [
  { label: 'usd', value: 'usd' },
  { label: 'eur', value: 'eur' },
  { label: 'pln', value: 'pln' },
  { label: 'bam', value: 'bam' },
  { label: 'bgn', value: 'bgn' },
  { label: 'czk', value: 'czk' },
  { label: 'gbp', value: 'gbp' },
  { label: 'huf', value: 'huf' },
  { label: 'isk', value: 'isk' },
  { label: 'kzt', value: 'kzt' },
  { label: 'mkd', value: 'mkd' },
  { label: 'mdl', value: 'mdl' },
  { label: 'ron', value: 'ron' },
  { label: 'rub', value: 'rub' },
  { label: 'rsd', value: 'rsd' },
  { label: 'sek', value: 'sek' },
  { label: 'chf', value: 'chf' },
  { label: 'try', value: 'try' },
  { label: 'uah', value: 'uah' },
  { label: 'byn', value: 'byn' },
  { label: 'hrk', value: 'hrk' },
  { label: 'dkk', value: 'dkk' },
  { label: 'nok', value: 'nok' },
];

export const allowedCountryCodes: string[] = [
  'AF',
  'AL',
  'DZ',
  'AD',
  'AM',
  'AT',
  'AZ',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EG',
  'EE',
  'FI',
  'FR',
  'GR',
  'DE',
  'GB',
  'GR',
  'HU',
  'IS',
  'IR',
  'IQ',
  'IE',
  'IL',
  'IT',
  'KZ',
  'XK',
  'KG',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MA',
  'MD',
  'MC',
  'ME',
  'NL',
  'NO',
  'PK',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'TJ',
  'TN',
  'TR',
  'TM',
  'UA',
  'UZ',
];
